var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "3",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "ShoppingCartIcon",
      "color": "primary",
      "statistic": _vm.cardPenjualan,
      "statistic-title": "Total Penjualan"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/penjualan');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "3",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "CreditCardIcon",
      "color": "success",
      "statistic": _vm.cardCollection,
      "statistic-title": "Collection"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/collection');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "3",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "ArchiveIcon",
      "color": "warning",
      "statistic": _vm.cardBarang,
      "statistic-title": "Barang"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/barang');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "3",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "BoxIcon",
      "color": "danger",
      "statistic": _vm.cardStokBarang,
      "statistic-title": "Stok Barang (Mobil)"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/kendaraan-barang');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "TruckIcon",
      "color": "primary",
      "statistic": _vm.cardKendaraan,
      "statistic-title": "Total Kendaraan"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/kendaraan');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "UsersIcon",
      "color": "success",
      "statistic": _vm.cardKaryawan,
      "statistic-title": "Total Karyawan"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/karyawan');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "BarChart2Icon",
      "color": "warning",
      "statistic": _vm.cardSales,
      "statistic-title": "Rank Sales"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/rank-sales');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sales-graphic')], 1), _c('br'), _c('br'), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('profit-and-loss-graphic')], 1), _c('br'), _c('br')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }